module.exports = __webpack_public_path__ + "static/img/Icon1.a7408f95.svg";